<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-boxes"></i> Inventory Pendukung
                </div>
                <div class="card-tools mr-0">
                    <button :disabled="isLoading" type="button" class="btn btn-primary" @click="printList">
                        <i class="fas fa-print"></i> Print
                    </button>
                    <button v-if="$can('create inventory pendukung')" type="button" class="btn btn-primary" @click="addInventory">
                        <i class="fas fa-plus-square"></i> Inventory Pendukung
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-2">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/inventory-pendukungs"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="stock" slot-scope="props">
                            <span :class="props.rowData.stock_warning ? 'text-danger font-weight-bold' : ''">
                                {{ props.rowData.stock }}
                                <i v-if="props.rowData.stock_warning" class="fas fa-exclamation-circle" :title="props.rowData.stock_warning"></i>
                            </span>
                        </template>
                        <template slot="action" slot-scope="props">
                            <button v-if="$can('create inventory pendukung')" type="button" title="Edit" @click="edit(props.rowData)" class="btn btn-link px-1"><i class="fas fa-edit"></i></button>
                            <button v-if="isSuperAdmin" type="button" title="Delete" @click="deleteItem(props.rowData)" class="btn btn-link px-1 text-danger"><i class="fas fa-trash-alt"></i></button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="editModal" size="md" :hide-header="true" :hide-footer="true">
            <edit-form :value="currentInventoryPendukung" :gudang="userGudang" @saved="saved" @cancel="editModal = false"></edit-form>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import SearchBar from './SearchBar';
import ExportMixin from '../../mixin/export';
import EditForm from './Form';

export default {
    name: "inventory-pendukung",

    components: {
        SearchBar,
        EditForm,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentInventoryPendukung: null,
            searchText: '',
            searchDate: '',
            searchGudangId: '',
            editModal: false,
            gudang: null,
        }
    },

    created() {
    },

    mounted() {
        if (this.userGudang) {
            this.loadGudang(this.userGudang.id);
        }
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'name',
                    title: 'Nama',
                    sortField: 'name',
                },
                {
                    name: 'gudang.name',
                    title: 'Gudang',
                    sortField: 'gudang_name',
                },
                {
                    name: 'stock_minimal',
                    title: 'Stock Minimal',
                    sortField: 'stock_minimal',
                },
                {
                    name: '__slot:stock',
                    title: 'Stock',
                    sortField: 'stock',
                },
                {
                    name: 'created_at',
                    title: 'Dibuat Pada',
                    sortField: 'created_at',
                    callback: 'formatDatetime',
                },
                {
                    name: 'updated_at',
                    title: 'Diperbarui Pada',
                    sortField: 'updated_at',
                    callback: 'formatDatetime',
                },
                {
                    name: '__slot:action',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "updated_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                gudang_id: this.searchGudangId,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchGudangId = search.searchGudangId;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = '';
            this.searchGudangId = '';
            this.refresh();
        },

        addInventory() {
            this.currentInventoryPendukung = null;
            this.editModal = true;
        },

        edit(rowData) {
            this.currentInventoryPendukung = Object.assign({}, rowData);
            this.editModal = true;
        },

        saved() {
            this.editModal = false;
            this.currentInventoryPendukung = null;
            this.refresh();
        },

        printList() {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            let params = this.convertExportParams('print');
            newIframe.src = `/inventory-pendukungs/list/print` + '?' + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        deleteItem(rowData) {
            let self = this;

            Swal.fire({
                title: 'Apakah anda yakin?',
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, hapus!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.isLoading = true;
                    self.$Progress.start();
                    axios({
                        method: 'delete',
                        url: '/api/inventory-pendukungs/' + rowData.id,
                    })
                    .then(function (response) {
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });
                        self.isLoading = false;
                        self.$Progress.finish();
                        self.refresh();
                    })
                    .catch(function (error) {
                        self.responseFailed(error);
                    });
                }
            })
        },
    },
}
</script>
